import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FUNNEL_PAYMENT_PROCESSING_STEP } from '../../../constants/funnel';

import ButtonComponent from '../../button/ButtonComponent';

const NextStepButton = ({ setStateOfTransaction, paymentType, i18n, lyziFetchingPay }) => {
    const disableButton = !paymentType || lyziFetchingPay;

    return (
        <ButtonComponent
            color="main"
            cssClass="nextStepButton"
            text={i18n.PAYMENT_METHOD_BUTTON}
            onClick={() => setStateOfTransaction(FUNNEL_PAYMENT_PROCESSING_STEP)}
            disabled={disableButton}
        />
    );
};

NextStepButton.propTypes = {
    setStateOfTransaction: PropTypes.func,
    paymentType: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        lyziFetchingPay: state.lyzi.fetchingPay
    };
};

export default connect(mapStateToProps)(NextStepButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/NextStepButton.js